import React from "react"
import { makeStyles } from "@material-ui/styles"
import { Chip } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
  root: {
    fontWeight: "600",
    color: "white",
    backgroundColor: theme.palette.active.main,
  },
}))

const ActiveChip = ({ className, label = "Active" }) => {
  const classes = useStyles()

  return <Chip label={label} classes={classes} className={className} size="small" />
}

export { ActiveChip }
